import { ref as k, unref as n, watch as r } from "vue";
import { useIdle as C } from "../node_modules/.pnpm/@vueuse_core@10.5.0_vue@3.3.4/node_modules/@vueuse/core/index.js";
import { useCookies as v } from "../node_modules/.pnpm/@vueuse_integrations@10.5.0_axios@1.6.2_universal-cookie@6.1.1_vue@3.3.4/node_modules/@vueuse/integrations/useCookies.js";
import p from "../node_modules/.pnpm/universal-cookie@6.1.1/node_modules/universal-cookie/es6/Cookies.js";
import { useDebounceFn as b } from "../node_modules/.pnpm/@vueuse_shared@10.5.0_vue@3.3.4/node_modules/@vueuse/shared/index.js";
const N = {
  secondsUntilIdle: 900,
  activityCookieName: "session_timer_start",
  cookieDomain: ".swordhealth.tech",
  enabled: !0
};
function w(c) {
  const e = {
    ...N,
    ...c
  }, s = k(null), { idle: l, lastActive: a, reset: t } = C(e.secondsUntilIdle * 1e3, { listenForVisibilityChange: !1 }), { addChangeListener: m, get: u, set: d } = v([], {}, new p());
  m(({ name: o }) => {
    const i = u(e.activityCookieName);
    !n(e.enabled) || o !== e.activityCookieName || !i || Number.isNaN(Number(i)) || (s.value = Number(i), t());
  });
  const f = b((o) => {
    n(e.enabled) && d(e.activityCookieName, o, { path: "/", domain: e.cookieDomain });
  }, 500);
  return r(() => n(e.enabled), () => {
    t();
  }), r(() => a.value, f), {
    idle: l,
    resetIdle: t,
    lastActive: s,
    lastActiveInApp: a
  };
}
export {
  w as default,
  w as useActivityTracker
};
